import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import defaultLocales from 'globals/locales/default';
import { ReactComponent as CopyIcon } from 'assets/icons/ui/copy.svg';
import { ReactComponent as VisibilityIcon } from 'assets/icons/ui/visibility.svg';
import { ReactComponent as VisibilityOffIcon } from 'assets/icons/ui/visibility-off.svg';
import { useSnackbar } from 'notistack';
import { InputAdornment } from '@material-ui/core';
import { getIconStyle } from './FsCopyPasteInput.style';
import FsSimpleInput from '../FsDefaultInput';
import { FsDefaultInputProps } from '../FsDefaultInput/FsDefaultInput';

interface State {
  password: string;
  showPassword: boolean;
}

const FsCopyPasteInput: React.FC<FsDefaultInputProps> = ({
  children,
  ...otherInputProps
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const iconStyle = getIconStyle();

  const [values, setValues] = React.useState<State>({
    password: '',
    showPassword: false,
  });

  const handleClickCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(otherInputProps.value as string);
      if (otherInputProps.name)
        enqueueSnackbar(
          `${otherInputProps.label} ${defaultLocales.copyPasteSuccessNotificationSuccess.suffix}`,
          {
            variant: 'success',
          }
        );
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(defaultLocales.copyPasteNotificationError);
    }
  };

  const handleClickReveal = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <FsSimpleInput
      {...otherInputProps}
      type={
        otherInputProps.type === 'password' && !values.showPassword
          ? 'password'
          : 'text'
      }
      placeholder={undefined}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            {otherInputProps.type === 'password' && (
              <IconButton
                onClick={handleClickReveal}
                onMouseDown={handleMouseDownPassword}
              >
                {values.showPassword && <VisibilityIcon style={iconStyle} />}
                {!values.showPassword && (
                  <VisibilityOffIcon style={iconStyle} />
                )}
              </IconButton>
            )}

            <IconButton onClick={handleClickCopy}>
              <CopyIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FsCopyPasteInput;
